import styleConfig from '../../muiTheme';

const styles = () => {
  const {
    palette: {
      primary: { main },
      gray: { grayC },
      white,
    },
  } = styleConfig;

  return {
    iconBtn: {
      color: white,
    },
    SvgIcon: {
      color: white,
      height: 23,
      width: 23,
    },
    dialog: {
      backgroundColor: main,
      padding: '0 0 0 15px',
    },
    pTag: {
      color: white,
      flex: 1,
      padding: 0,
      fontSize: 16,
      margin: 0,
    },
    mainDiv: {
      display: 'flex',
      alignItems: 'center',
    },
    dialogContent: {
      padding: 20,
      flexDirection: 'column',
    },
    formControlLabel: {
      margin: 0,
      padding: '5px',
      border: `1px solid ${grayC}`,
      display: 'flex',
      '&:focus': { boxShadow: `0 1px ${main}` },
    },
    btn: {
      margin: '16px !important',
    },
    dialogActions: { margin: 0 },

    formInputControl: { width: 0, height: 0, opacity: 1 },
  };
};

export default styles;
